<button class="x-button">
  <svg-icon
    class="x-button__icon"
    src="assets/images/icons/cart-product-x.svg"
    [applyClass]="true"
  ></svg-icon>
</button>
